module.exports = __webpack_public_path__ + "img/result_txt_yl.dce24562.png";